export const MOBILE_FOOTER_HEIGHT = 62;
